<script>
  import { step } from '../../../../../store/common';
  import Right from './components/Right/Right.svelte';
  import Left from './components/Left/Left.svelte';

  const onClick = () => {
    step.set(3);
  };
</script>

<div class="uk-modal-body">
  <div class="uk-margin-remove-top" data-uk-grid>
    <Left />

    <Right />
  </div>
</div>

<div class="uk-modal-footer ">
  <a
    class="uk-button uk-button-secondary uk-width"
    data-uk-toggle
    on:click={onClick}
  >
    Get Price Quote
  </a>
</div>
